
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/season-break",
      function () {
        return require("private-next-pages/season-break.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/season-break"])
      });
    }
  